import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 1
    },
    guestdetailData: {
        color: '#000',
        fontSize: 10,
        fontFamily: 'Helvetica-Oblique',
        marginBottom: 5,
       
    },
  });

const GuestDetails = ({invoice}) => {

    var items1 = (JSON.stringify(invoice));
      var items2 = JSON.parse(items1);
      var items3 = JSON.parse(items2);
    const rows =  items3.child!=null && items3.child.slice(0, 1).map( item => 
        <View style={styles.headerContainer}>
                <Text style={styles.guestdetailData}>Name:- {item.first_name} {item.last_name}</Text>
                <Text  style={styles.guestdetailData}>Contact Number:- {item.contact_number}</Text>
            <Text  style={styles.guestdetailData}>EmailID:-  {item.email}</Text>
        </View >
    )
    return (<Fragment>{rows}</Fragment> )
  };
  export default GuestDetails